/**
 * @title lucidworks.js: Sub-module of LucidWorks feature
 * @description This module encapsulates all of the
 * functionality related to the lucidworks search component.
 * @dependency
 */
define([], function() {
	let numCounter = 0;
	let prevSuggestionType= '';
  let LWSearch = {
    fusionQueryId: null,
    origSrchTerm: null,
    /**
     * The initializing function modules use
     * to call.
     * @return {void}
     */
    init: function() {
      let lwTypeAheadEnabled = this.isLWTypeAheadEnabled();

      if (lwTypeAheadEnabled) {
        COSTCO.util.safe(this.lwTypeAhead)();
      }
    },
    /**
     * Set Up Bootstrap TypeAhead with Bloodhound as remote data source
     * @return {void}
     */
    lwTypeAhead: function() {
    	
      LWSearch.loadTypeaheadConfig();
      
      let search = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,

        remote: {
          url: lwTypeAhead.endpoint,
          prepare: function(query, settings) {
            let serviceURL = settings.url + '?q=' + encodeURIComponent(query);
            serviceURL += '&locale=' + wcs.locale.replace('_', '-') + '&loc=' + LWSearch.getWarehouseLocations() + '&rowsPerGroup=' + lwTypeAhead.maxPerType;
            
            if(typeof(lwTypeAhead.enableZipRestriction) != 'undefined' && lwTypeAhead.enableZipRestriction != 'undefined' && lwTypeAhead.enableZipRestriction.length > 0 && lwTypeAhead.enableZipRestriction == 'true'){
	            
            	let userStateCode = $.cookie('invCheckStateCode');
            	let userPostalCode = $.cookie('invCheckPostalCode');
            	
	            if(typeof(userStateCode) == 'undefined' || userStateCode == 'undefined' || userStateCode.length == 0 || typeof(userPostalCode) == 'undefined' || userPostalCode == 'undefined' || userPostalCode.length == 0){
	            	userStateCode = lwTypeAhead.defaultStateCode;
	            	userPostalCode = lwTypeAhead.defaultZipCode;
	            }
	            
	            if(typeof(userStateCode) != 'undefined' && userStateCode != 'undefined' && userStateCode.length > 0 && typeof(userPostalCode) != 'undefined' && userPostalCode != 'undefined' && userPostalCode.length > 0){
		            if(userPostalCode.indexOf("-") != -1){
	            		userPostalCode = userPostalCode.split('-')[0];
	            	}
	            	
	            	if(userPostalCode.indexOf(" ") != -1){
	            		userPostalCode = userPostalCode.replace(/ /g, '%20');
	            	}
	
	            	serviceURL = serviceURL+ '&userLocation='+ userStateCode;
	            	serviceURL = serviceURL+ '&userPostal='+ userPostalCode;
	            }
	            
            }
            
            if(lwTypeAhead.enableTravel){
            	serviceURL = serviceURL+ '&includeTravelInSearch='+ lwTypeAhead.enableTravel;
            }
            //Check for National Delivery Flow
            var bdZipCookie = COSTCO.util.getBDZipCookie();
            if(bdZipCookie!=null && bdZipCookie.externalCarrier=='ND'){
            	serviceURL += '&nationalDelivery=true'; 
            }
            settings.headers = {
              Authorization: 'Basic ' + lwTypeAhead.basicAuth,
            };
            settings.url = serviceURL;
            return settings;
          },
          rateLimitBy: 'throttle',
          rateLimitWait: lwTypeAhead.rateLimitWait,
          filter: function(data) {
            let firstSection = [];
            let lastSection = [];
            let allSuggestions = [];
            LWSearch.fusionQueryId = data.fusion.fusionQueryId;
            LWSearch.origSrchTerm = $('#search-field').val();
            $.each(data.response.docs, function(i, suggestion) {
              switch (suggestion.type.toLowerCase()) {
                case 'popularsearch':
                  suggestion.displayOrder = 1;
                  firstSection.push(suggestion);
                  break;
                case 'shadowdimension':
                  suggestion.displayOrder = 2;
                  firstSection.push(suggestion);
                  break;
                case 'category':
                  suggestion.displayOrder = 3;
                  firstSection.push(suggestion);
                  break;
                case 'brand':
                  suggestion.displayOrder = 4;
                  firstSection.push(suggestion);
                  break;
                case 'product':
                  suggestion.displayOrder = 5;
                  if (suggestion.pharmacy_drug_id) {
                    suggestion.FullImage = lwTypeAhead.cmppProductImage;
                  }
                  lastSection.push(suggestion);
                  break;
                case 'warehouse':
                  suggestion.displayOrder = 6;
                  suggestion.WarehouseAddress = LWSearch.normalizeWarehouseText(suggestion.WarehouseAddress);
                  lastSection.push(suggestion);
                  break;
              }
            });

            search.sorter(firstSection);
            search.sorter(lastSection);

            let firstSectionLength = firstSection.length;
            let lastSectionLength = lastSection.length;

            let defaultSize = lwTypeAhead.maxSuggestions - lwTypeAhead.maxFirstSection;
            lastSectionLength = defaultSize;

            if (firstSectionLength < lwTypeAhead.maxFirstSection) {
              lastSectionLength = lwTypeAhead.maxSuggestions - firstSectionLength;
            } else {
              firstSectionLength = lwTypeAhead.maxFirstSection;
            }

            firstSection = firstSection.slice(0, firstSectionLength);
            lastSection = lastSection.slice(0, lastSectionLength);
            allSuggestions = firstSection.concat(lastSection);

            // Adding Border
            let display = [];
            data = allSuggestions || [];
            let count = 0;
            let curObjType = '';
            $.each(data, function(i, suggestion) {
              if (suggestion.type != curObjType && count > 0) {
                suggestion.border = 'border';
              }
              curObjType = suggestion.type;
              count++;
              display.push(suggestion);
            });

            return display;
          },
        },
        sorter: function(suggestionA, suggestionB) {
          if (suggestionA.displayOrder < suggestionB.displayOrder) {
            return -1;
          } else if (suggestionA.displayOrder > suggestionB.displayOrder) {
            return 1;
          } else return 0;
        },
      });

      $('#search-widget .typeahead')
        .typeahead({
          hint: true,
          highlight: true,
          minLength: parseInt(lwTypeAhead.minChar),
        }, {
          name: 'search',
          display: 'term',
          source: search,
          limit: 999,
          templates: {
            suggestion: function(data) {
            	numCounter = data.type == prevSuggestionType ? numCounter + 1 : 0;
            	prevSuggestionType = data.type;
            	let numId = numCounter == 0 ? '' : numCounter;
            	let travelTile = false;
	        	if(data.travel_destination){
	          	  travelTile = true;
	            }
              let _in = '<span class="hidden-xs">&nbsp;in&nbsp;</span>';
              let category = data.category ? _in + '<span class="category hidden-xs">' + data.category + '</span>' : '';
              let privateTag = data.leads_to_fsa_chdi ? 'data-bi-private ="true" data-private ' : '';
              if (data.type == 'Warehouse') {
                let warehouse = '';
                warehouse = ' Warehouse ' + data.WarehouseAddress;
                return ('<div '+ privateTag +' automation-id=sugguestion-' + data.type + '-' + data.refinementId + ' class=' + (data.border ? 'border' : '') + '>' + data.value + warehouse + '</div>');
              }
              if (data.type == 'Product'&& !travelTile) {
            	privateTag = data.item_fsa_eligible || data.item_chdi_eligible ? 'data-bi-private ="true" data-private ="true"' : '';
                let productImage = '<img class="product-image" src=' + data.FullImage + '>';
                return ('<h6 '+ privateTag +'automation-id=sugguestion-' + data.type + numId + ' class=' + (data.border ? 'border' : '') + '>' + productImage + data.label + '</h6>');
              }
              if (travelTile) {
                  let productImage = '<img class="product-image" src=' + data.travel_imageURL + '>';
                  return ('<h6 automation-id=sugguestionTravel-' + data.type + numId + ' class=' + (data.border ? 'border' : '') + '>' + productImage + data.travel_description + '</h6>');
                }
              return '<div '+ privateTag +'automation-id=sugguestion-' + data.type + numId + '>' + data.term + category + '</div>';
            },
          },
        })
        .on('typeahead:render', function() {
          if (!$('.tt-dataset :first-child.tt-suggestion').hasClass('border')) {
            $('<hr>').insertBefore($('.tt-dataset .border'));
          }
        })
        .on('typeahead:selected', function(event, suggestion) {
          let currEvent = 'search';
          let srchType = null;
          let brandFacet = 'Brand_attr-';
          //const searchProviderParam = 'searchProvider';
          //const searchProviderFlag = 'lucidworks';
          switch (suggestion.type.toLowerCase()) {
            case 'popularsearch':
              $(this).closest('.CatalogSearchForm').submit();
              srchType = 'type ahead:popular';
              LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
              break;
            case 'shadowdimension':
              let searchString = suggestion.baseUrl + '?refine=||' + brandFacet + LWSearch.cleanSDRefine(suggestion.Brand_attr);
              srchType = 'type ahead:shadow dimension';
              LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
              window.location.href = searchString;
              break;
            case 'category':
              let categoryUrl = suggestion.baseUrl;
              srchType = 'type ahead:category';
              LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
              window.location.href = categoryUrl;
              break;
            case 'brand':
              $('.CatalogSearchForm').append('<input type="hidden" name="refine" value="||' + brandFacet + LWSearch.cleanBrandRefine(suggestion.Brand_attr) + '">');
              //$('.CatalogSearchForm').append('<input type="hidden" name="' + searchProviderParam + '" value="' + searchProviderFlag + '">');
              srchType = 'type ahead:brand';
              LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
              $(this).closest('.CatalogSearchForm').submit();
              break;
            case 'product':
              srchType = 'type ahead:product';
              
              let pdpUrl = '';
              if(suggestion.travel_pageURL){
            	  pdpUrl = suggestion.travel_pageURL;
            	  srchType = 'type ahead:travel';
              }else{
            	  let suggestionTerm = suggestion.term.replaceAll('(', '').replaceAll(")", "")
            	 pdpUrl= '/' + LWSearch.getSEOFriendlyURL(suggestionTerm) + '.product.' + suggestion.group_id + '.html';
              }
              if (suggestion.pharmacy_drug_id) {
                pdpUrl = '/cmpps?drugIdentifierParam=' + suggestion.pharmacy_drug_id + '&drugNameParam=' + suggestion.term;
              }
              LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
              window.location.href = pdpUrl;
              break;
            case 'warehouse':
              srchType = 'type ahead:warehouse';
              let displayLabel = suggestion.label + ' ' + suggestion.type + ' ' + suggestion.WarehouseAddress;
              LWSearch.pushAdobeAnalyticsData(currEvent, srchType, displayLabel, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
              window.location.href = suggestion.baseUrl;
              break;
          }
        });
    },
    /**
     * Feature Toggle for LW Typeahead
     */
    isLWTypeAheadEnabled: function() {
      if (typeof lwTypeAhead !== 'undefined') {
        //let lwTypeAheadEnabled = lwTypeAhead.searchProvider.toLowerCase() === 'lucidworks';
        //let queryParams = window.location.search.toLowerCase();
        //if (queryParams.includes('searchprovider=lucidworks')) {
          lwTypeAheadEnabled = true;
        //} else if (queryParams.includes('searchprovider=solr') || queryParams.includes('searchprovider=solr>lucidworks')) {
        //  lwTypeAheadEnabled = false;
        //}
        // Added for A/B testing
        //if (!lwTypeAheadEnabled && $('#typeAheadSearchProvider').val() === this.searchProviderLW) {
          //lwTypeAheadEnabled = true;
        //}
        return lwTypeAheadEnabled;
      }
      return false;
    },
    /**
     * Performs string manipulations to extract warehouse number from warehouse cookie
     * based on catalog type.
     */
    fetchWarehouseCookieVal: function(catalogType) {
      let result;
      let warehouseCookie = $.cookie('WAREHOUSEDELIVERY_WHS');
      if (warehouseCookie != null && warehouseCookie != '') {
    	warehouseCookie=JSON.parse(warehouseCookie);
    	if (warehouseCookie[catalogType] != null && warehouseCookie[catalogType] != '') {
      	  if (catalogType.toLowerCase() === 'nearestwarehouse') {
        	    result = warehouseCookie[catalogType]['catalog'];
            } else {
            	result = warehouseCookie[catalogType]
            }
        }
      }
      return result;
    },
    
    /**
     * Performs string manipulations to extract warehouse number from warehouse cookie
     * based on catalog type.
     */
    getCookie: function(cookieName) {
      let cookieValue = $.cookie(cookieName);
      return cookieValue;
    },
    
    
    /**
	 * Get grocery and distribution location data
	 */
    getRegionalLocations: function() {
    	let whLocation = '';
    	let regionalWH = this.fetchWarehouseCookieVal('distributionCenters');
        let groceryWH  = this.fetchWarehouseCookieVal('groceryCenters');
        if (regionalWH) {
            whLocation = whLocation + regionalWH;
          }
        if (groceryWH) {
        	if(whLocation!=''){
        	 whLocation = whLocation + ',' + groceryWH;
        	}else{
        	 whLocation = whLocation + groceryWH;
        	}
           
          }
        return whLocation;
    },
    /**
     * Get location data for LW
     */
    getWarehouseLocations: function() {
      let whLocation = '';
      if (COSTCO.util.isBusinessDelivery()) {
        whLocation = COSTCO.util.getBDZipCookie().warehouseNumber;
        whLocation=whLocation.replace('-ND','');
        if (!whLocation) {
          if (wcs.langId < -1) {
            whLocation = 889;
          } else {
            whLocation = 888;
          }
        }
      } else {        
        let regionalWH = this.fetchWarehouseCookieVal('distributionCenters');
        let groceryWH  = this.fetchWarehouseCookieVal('groceryCenters');
        let nearestWH  = this.fetchWarehouseCookieVal('nearestWarehouse');        
        if (regionalWH) {
          whLocation = whLocation + regionalWH;
        }
        if (groceryWH) {
          whLocation = (whLocation != '') ? (whLocation + ',' + groceryWH) : whLocation + groceryWH;
        }
        if (nearestWH) {
          whLocation = (whLocation != '') ? (whLocation + ',' + nearestWH) : whLocation + nearestWH;
        }
      }
      return whLocation;
    },
    /**
     * Push Digital for Adobe analytics
     */
    pushAdobeAnalyticsData: function(currEvent, srchType, srchTerm, actualSrchTerm, fusionQueryId) {
      window.digitalDataEvents = window.digitalDataEvents || [];
      digitalDataEvents.push({
        event: currEvent,
        searchType: srchType,
        searchTerm: srchTerm,
        actualSearchTerm: actualSrchTerm,
        fusionQueryId: fusionQueryId,
      });
    },
    /**
     * Create SEO friendly url from product name
     */
    getSEOFriendlyURL: function(productName) {
      return productName.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/#/g, '') // Replace # with empty string
        .replace(/%/g, '') // Replace % with empty string
        .replace(/"/g, '') // Replace " with empty string
        .replace(/'/g, '') // Replace ' with empty string
        .replace(/\?/g, '') // Replace ? with empty string
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    },
    encodeUrl: function(url) {
        return encodeURIComponent(url).replace(/'/g, '%27').replace(/"/g, '%22');
     },
    /**
     * Clean Brand facet value
     */
    cleanBrandRefine: function(brandFacet) {
      // Single encode brand facet value
      let brandEncoded = this.encodeUrl(brandFacet);
      // Replace encoded spaces with + to match Java URLEncoder
      return brandEncoded.toString().replace(/%20/g, '+');
    },
    /**
     * Clean Shadow Dimension facet value
     */
    cleanSDRefine: function(brandFacet) {
      // Double encode brand facet value
      let brandEncoded = escape(this.encodeUrl(brandFacet));

      // Replace encoded spaces with %2B to match Java URLEncoder
      return brandEncoded.toString().replace(/%2520/g, '%2B');
    },
    /**
     * Utility function to fix warehouse character casing
     */
    normalizeWarehouseText: function(whText) {
      let firstLetterRx = /(^|\s)[a-z]/g;

      function upperCase(str) {
        return str.toUpperCase();
      }
      whText = whText.toLowerCase();
      return whText.replace(firstLetterRx, upperCase);
    },
    /*
     * Function to specify behavior of lw typeahead a/b config
     */
    loadTypeaheadConfig: function() {
    	// Following lines of code allow minChars and maxSuggestions 
        // for lw typeahead to be configured from adobe target.
    	let sessionParams = sessionStorage.getItem("lw-typeahead-ab-parms");
        let adobeLwConfig;
        if (COSTCO.util.objectExistsAndNonEmpty(sessionParams)) {
        	adobeLwConfig = JSON.parse(sessionParams) 
        }
        
        if (COSTCO.util.objectExistsAndNonEmpty(adobeLwConfig)) {
      	  let minCharConfig = adobeLwConfig.minchars;
      	  let limitConfig = adobeLwConfig.maxchars;
      	  lwTypeAhead.minChar = COSTCO.util.objectExistsAndNonEmpty(minCharConfig) ? minCharConfig : lwTypeAhead.minChar;
      	  lwTypeAhead.maxSuggestions = COSTCO.util.objectExistsAndNonEmpty(limitConfig) ? limitConfig : lwTypeAhead.maxSuggestions;
        }
        return;
    },
    /**
     * Function to reload page on ZSR for edge case
     */
    ZSR_reloader: function(){
    	let lw_whsName = $('#whsName').val();
    	let isCategoryPage = $('#isCategoryPage').val();
    	let isReloaded = COSTCO.util.getParameterByName('reloaded') == null ? false : true;
    	let whsRegionalCookieValue = LWSearch.fetchWarehouseCookieVal('Regional');
    	if(!isReloaded
			&& isCategoryPage != null
			&& whsRegionalCookieValue
			&& lw_whsName !== whsRegionalCookieValue
			) {
    		document.location.search = COSTCO.util.insertParamInUrl('reloaded', 'true');
    	}
    },
  };

  // If user is on android or iOS mobile device, disable keyboard autocorrect for searches
  $('#search-field').focusin(function() {
    if (/Android|iPhone|iPad/i.test(navigator.userAgent) && $(this).attr('autocorrect') !== 'off') {
      $(this).attr('autocorrect', 'off');
    }
  });

  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.LWSearch = LWSearch;

  return LWSearch;
});



// WEBPACK FOOTER //
// ./js/global/lucidworks.js